export const colors = {
  separator: {
    border: '#CCCCCC',
    divider: '#E5E5E5',
  },
  page: {
    surface: '#FFFFFF',
    background: '#F2F2F2',
    plateLight: '#F7F7F7',
    plateMedium: '#D9D9D9',
    plateDark: '#4D4D4D',
  },
  feature: {
    primary: '#000000',
    secondary: '#767676',
    placeholder: '#B2B2B2',
    onInteraction: '#FFFFFF',
  },
  brand: {
    primary: '#222222',
    secondary: '#F47624',
  },
  interaction: {
    main: '#005CEA',
    hover: '#3584FF',
    active: '#1049A1',
    disabled: '#D9D9D9',

    surfaceHover: '#E9F1FF',
    surfaceActive: '#C7DDFF',
    surfaceDisabled: '#F7F7F7',

    surfaceSuggestionHover: '#F4EBFF',
    surfaceSuggestionActive: '#E6D3FF',

    plateMediumHover: '#CECECE',
    plateMediumActive: '#CECECE',

    overlayHover: '#0048DC1F',

    destructive: '#E11D1D',
    destructiveHover: '#FF5E5E',
    destructiveActive: '#CC1F1F',

    suggestion: '#8C41ED',
    suggestionHover: '#A163EF',
    suggestionActive: '#782CDA',

    focus: 'rgba(0,72,220,0.345)',

    modified: '#FFEEB6',

    superuser: '#FF00E5',

    tooltip: '#3A3A3A',
  },
  status: {
    notApplicable: '#B2B2B2',
    notStarted: '#787878',
    onHold: '#E11D1D',
    inProgress: '#F59300',
    nearComplete: '#FFD600',
    complete: '#1DC502',
  },
  alert: {
    assistance: '#8C41ED',
    error: '#E11D1D',
    warning: '#F59300',
    success: '#1DC502',
    info: '#06D1DE',

    surfaceAssistance: '#F4EBFF',
    surfaceError: '#FFCACA',
    surfaceWarning: '#FFE2B7',
    surfaceSuccess: '#CFFFC8',
    surfaceInfo: '#DFFDFF',
  },
  tag: {
    ITAR: '#E11D1D',
  },
  overlay: {
    drawer: 'rgba(0,0,0,0.25)',
    modal: 'rgba(0,0,0,0.25)',
  },
  avatar: {
    magenta: '#A51A54',
    copper: '#C9500B',
    brass: '#B37702',
    green: '#246B41',
    teal: '#087980',
    blue: '#155CBB',
    purple: '#5E35B5',
    lead: '#4D4D4D',
  },
  gradients: {
    thumbnail: 'linear-gradient(150deg, #fff 0%, #cccccc 100%)',
  },
  geometry: {
    x: '#E95242',
    y: '#599773',
    z: '#3075D2',
  },
  featureReleaseStatus: {
    publicBeta: '#5037D5',
    privateBeta: '#DF2669',
  },
} as const;
